import { NavbarTemplate } from "../../componentes/molecules/Navbar";

export default function Navbar() {
  return (
    <NavbarTemplate/>
  );
}
